module.exports = __webpack_public_path__ + "03e0087e63ed994f06ab8efa8aafa0db.fbx";